<template>
  <div class="cmslist">
    <div class="container_wrap">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item v-for="(item, index) in breadData" :key="index"><a>{{item.name}}</a></el-breadcrumb-item>
      </el-breadcrumb> -->
      <!--      <div class="overall_query_tabs">-->
      <!--        <div class="overall_query_tab" @click="getall">全部</div>-->
      <!--        <div-->
      <!--          class="overall_query_tab"-->
      <!--          v-for="(item, index) in catelist"-->
      <!--          :key="index"-->
      <!--          :class="item.class"-->
      <!--          @click="overallquerytabClick(index, item)"-->
      <!--        >-->
      <!--          {{ item.name }}-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="left_and_right_container">
        <div class="container_left">
          <!-- <news-list-item specialTagName="推荐"></news-list-item> -->
          <!-- <news-list-item specialTagName=""></news-list-item> -->
          <news-list-item
              v-for="(item, index) in newsListData2.slice(
              (currentPage - 1) * pageSize,
              currentPage * pageSize
            )"
              :key="index"
              :NewsItemData="item"
              @click.native="itemClickFun(item)"
          ></news-list-item>
        </div>
        <RightNav :list="list"></RightNav>
      </div>
      <el-pagination
          v-if="false"
          style="margin-left: 250px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="newsListData2.length"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import NewsListItem from "@/components/mainindex/NewsListItem";
import RightNav from "@/components/mainindex/RightNav";

export default {
  name: "CmsList",
  data() {
    return {
      list: [],
      recommendpics: [],
      recommendnews: [],
      catelist: [],
      pageSize: 5,
      currentPage: 1,
      searchdata: "", //搜索框model
      newsListData: [],
      newsListData2: [],
      targetCateId: this.$route.query.id,
      breadData: [{name: ""}],
      overallquerytabsArr: [
        {name: "全部", class: "overall_query_tab_active"},
        {name: "境外风采", class: ""},
        {name: "相关文件", class: ""},
        {name: "赛事列表", class: ""},
      ],
    };
  },
  components: {
    NewsListItem, RightNav
  },
  mounted() {
    // console.log(".............0",this.$store.state.breadPath)
    document.title = "境外交流"
    this.getNewsItemlist();
    if (this.$route.query && this.$route.query.id == 97) {
      this.getStoreBread(97);
    } else if (this.$route.query && this.$route.query.id == 115) {
      this.getStoreBread(115);
    }

    this.geRecommendlist()
  },
  methods: {
    geRecommendlist() {
      const that = this;
      that.$api.get(
          "/api/cms/recommendList",
          {
            cate_id: 13,
          },
          (res) => {
            this.list = res.data;
          }
      );
      // that.$api.get(
      //     "/api/cms/recommendList",
      //     {
      //       cate_id: 13,
      //     },
      //     (res) => {
      //       this.recommendpics = res.data;
      //     }
      // );
    },
    getall() {
      this.newsListData2 = this.newsListData;
      this.currentPage = 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
    },
    overallquerytabClick(index, item) {
      var action = [];
      for (var i = 0; i < this.newsListData.length; i++) {
        if (this.newsListData[i].cate_ids == item.id) {
          action.push(this.newsListData[i]);
        }
      }
      this.newsListData2 = action;
      this.currentPage = 1;
    },
    //获取面包屑的内容
    getStoreBread(cate_id) {
      var that = this;
      that.$api.get(
          "/api/cms/breadList",
          {
            cate_id: cate_id,
          },
          (res) => {
            // this.$message.success("发送成功");
            that.breadData = res.data;
            // console.log(res.data);
          },
          (r) => {
            that.$message.error(r.msg);
          }
      );
    },
    //新闻条点击事件
    itemClickFun(val) {
      this.$router.push({path: "/cmsdetail", query: {id: val.id}});
    },
    searchFun() {
      this.$message({type: "success", message: "search"});
    },
    //获取新闻列表
    getNewsItemlist() {
      const that = this;
      that.$api.get(
          "/api/cms/cmslist",
          {
            cate_id: 57,
          },
          (res) => {
            that.newsListData = res.data.list;
            this.catelist = res.data.cate_list;
            this.newsListData2 = res.data.list;
          },
          (r) => {
            that.$message.error(r.msg);
          }
      );
    },
  },
  watch: {
    $route: {
      handler() {
        this.targetCateId = this.$route.query.id;
        this.getNewsItemlist();
        // console.log("this.$route.",this.$route.query.id);
        // this.getCateTargetFun();
        if (this.$route.query && this.$route.query.id == 97) {
          this.getStoreBread(97);
        } else if (this.$route.query && this.$route.query.id == 115) {
          this.getStoreBread(115);
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.cmslist {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
  padding-bottom: 50px;
}

.container_wrap {
  width: 1240px;
  margin: 0 auto;
  // height: 1235px;
}

// .breadcrumb {
//   margin-top: 21px;
//   margin-left: 23px;
//   margin: 21px 0 20px 23px;
// }
// .cmslist_tabs {
//   margin: 21px 0 20px 23px;
// }
.overall_query_tabs {
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
  display: flex;
  flex-direction: row;
  margin: 30px 0 25px 30px;

  .overall_query_tab {
    margin-right: 40px;

    &:hover {
      cursor: pointer;
      color: #000000;

      &::after {
        content: "";
        display: block;
        width: 17px;
        height: 4px;
        background: #0091ff;
        border-radius: 3px;
        margin: 0 auto;
      }
    }
  }

  .overall_query_tab_active {
    color: #000000;

    &::after {
      content: "";
      display: block;
      width: 17px;
      height: 4px;
      background: #0091ff;
      border-radius: 3px;
      margin: 0 auto;
    }
  }
}

.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 40px;

  .container_left {
    width: 910px;
    min-height: 600px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 16px 45px 0 30px;
    box-sizing: border-box;
  }

}
</style>



// WEBPACK FOOTER //
// CmsList.vue?01dc06ea